/**
 * KAHVE KAVURMA MERKEZİ — Tadım Seti Dil / Metin Dosyası
 * assets/tadim-lang.js
 */
window.TADIM_LANG = {
  steps: {
    1: { eyebrow: 'ADIM 1 / 4', title: 'Kahve türünüzü seçin', desc: 'Tadım setinizi tercih ettiğiniz demleme yöntemine göre şekillendirelim.' },
    2: { eyebrow: 'ADIM 2 / 4', title: 'Çekirdek seçimi', desc: 'Koleksiyonumuzdan 5 farklı orijin seçin. Her biri 100 gr olarak ayrı ayrı paketlenecektir.' },
    3: { eyebrow: 'ADIM 3 / 4', title: 'Öğütme derecesi', desc: 'Tüm çekirdekler için geçerli olacak öğütme derecesini belirleyin.' },
    4: { eyebrow: 'ADIM 4 / 4', title: 'Sipariş önizleme', desc: 'Seçimlerinizi gözden geçirin ve tadım setinizi onaylayın.' },
  },
  types: {
    turk:     { title: 'Türk Kahvesi', desc: 'Türk kahvesi demleme karakterine uygun çekirdek profillerini keşfedin.' },
    filtre:   { title: 'Filtre Kahve', desc: 'V60, pour over ve French press demleme yöntemlerine uygun çekirdekleri tadın.' },
    espresso: { title: 'Espresso', desc: 'Espresso ekstraksiyonuna uygun çekirdek profillerini keşfedin.' },
  },
  grind: {
    cekirdek: { title: 'Çekirdek', desc: 'Maksimum tazelik için çekirdek olarak teslim edilir.' },
    filtre:   { title: 'Filtre Kahve', desc: 'V60, Chemex ve French press için orta öğütme.' },
    turk:     { title: 'Türk Kahvesi', desc: 'Türk kahvesi cezve demlenmesine uygun ince öğütme.' },
  },
  beanSelection: {
    counterComplete: '5 çekirdek seçildi — devam edebilirsiniz ✓',
    counterPending:  '{n} / 5 seçildi — {left} çekirdek daha ekleyin',
  },
  preview: {
    type: 'Kahve Türü', grind: 'Öğütme Derecesi',
    beans: 'Seçilen Çekirdekler', weight: 'Paket Ağırlığı',
    weightVal: '5 × 100 gr', total: 'Toplam',
  },
  buttons: {
    next: 'Devam →', back: '← Geri',
    addCart: 'Sipariş Oluştur — 700 ₺', adding: 'Ekleniyor...',
  },
  warnings: {
    noVariant: 'Ürün yapılandırılmamış. Lütfen yönetici ile iletişime geçin.',
  },
};